import '../common/base';
import VueMask from 'v-mask';
import locale from '../../../submodules/src/script/i18n/locale';
import shop from '../../../submodules/src/script/i18n/shop';
import general from '../../../submodules/src/script/i18n/general';
import cart from '../../../submodules/src/script/i18n/cart';
import date from '../../../submodules/src/script/i18n/date';
import Vue from './common/vue-common';
import CartRecommendations from './components/cart/recommendation/CartRecommendations.vue';
import Advantages from './components/common/Advantages.vue';
import CartFastDelivery from './components/cart/CartFastDelivery.vue';
import SalesRepCartShippingDays from './components/sales-rep/SalesRepCartShippingDays.vue';
import Cart from '../../../submodules/src/componentsV2/cart/Cart.vue';
import CashbackFaq from './components/cashback/CashbackFaq.vue';

Vue.use(VueMask);

new Vue({
    el: '#CartInstance',
    template: `
      <Cart>
        <template v-slot:cart-recommendations>
            <CartRecommendations/>
        </template>
        <template v-slot:advantages>    
            <Advantages :hidePromoBanner="true"/>
        </template>
        <template v-slot:cart-fast-delivery>
            <CartFastDelivery />
        </template>
        <template v-slot:sales-rep-cart-shipping-days>
            <SalesRepCartShippingDays />
        </template>
        <template v-slot:cashback-faq>
            <CashbackFaq :is-hotsite="false" />
        </template>
      </Cart>
    `,
    components: {
        Cart,
        CartRecommendations,
        Advantages,
        CartFastDelivery,
        SalesRepCartShippingDays,
        CashbackFaq,
    },
    i18n: locale(general(), cart(), shop(), date()),
});
